export default "__VITE_ASSET__CG7CS0sy__"